export default __webpack_public_path__ + "static/media/Slider2.9eca69ce.png";